import { BLOCKS } from '@contentful/rich-text-types';
import { createAnchorId } from '../../utils/createAnchorId.js';
import '../Div/index.js';
import { articleRichTextOptions } from './options/articleRichTextOptions.js';
import { RichText } from './RichText.js';
import { splitArticlePerParagraphs } from './utils/splitArticlePerParagraphs.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import { Div } from '../Div/Div.js';
const INTRODUCTION_ID = 'article_introduction';
function ArticleSections({
  color,
  content,
  richTextOptions,
  handleAnchorsChange
}) {
  const articleParagraphs = splitArticlePerParagraphs(content);
  return /*#__PURE__*/jsx(Fragment, {
    children: articleParagraphs?.map((paragraph, index) => {
      const firstParagraph = paragraph.content[0];
      const isHeading = firstParagraph.nodeType === BLOCKS.HEADING_2 || firstParagraph.nodeType === BLOCKS.HEADING_3 || firstParagraph.nodeType === BLOCKS.HEADING_4 || firstParagraph.nodeType === BLOCKS.HEADING_5 || firstParagraph.nodeType === BLOCKS.HEADING_6;
      let anchorId = isHeading ?
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
      createAnchorId(firstParagraph.content[0]?.value ?? '') : index === 0 ? INTRODUCTION_ID : '';

      // Replaces original anchor logic to prevent issues when duplicate headers with same anchor id's are present.
      if (firstParagraph.nodeType === BLOCKS.HEADING_2 && handleAnchorsChange) {
        anchorId = `${anchorId}-${index}`;
        const anchor = {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
          text: firstParagraph.content[0]?.value,
          anchor: anchorId
        };
        handleAnchorsChange?.(anchor);
      }
      return /*#__PURE__*/jsx(Div, {
        flexDirection: "column",
        id: anchorId,
        css: {
          '.rich-text h3 + ul': {
            paddingTop: 16
          }
        },
        children: /*#__PURE__*/jsx(RichText, {
          color: color,
          content: paragraph,
          richTextOptions: richTextOptions || articleRichTextOptions,
          paragraphSpacingTop: {
            sm: 3,
            lg: 4
          },
          defaultSpacingTop: {
            sm: 3,
            lg: 5
          }
        })
      }, index);
    })
  });
}
export { ArticleSections, INTRODUCTION_ID };
//# sourceMappingURL=ArticleSections.js.map
